<template>
  <div class="form-group">
    <label v-if="label"
           v-bind:class="{required: hasRequired}"
           :for="id">
      {{label}}
    </label>
    <div class="input-group" v-bind:class="{ 'is-invalid': validation.$error }">
      <input type="text"
             class="form-control"
             placeholder="hh:mm"
             aria-label="Time"
             v-mask="mask"
             :disabled="disabled"
             v-bind="$attrs"
             v-bind:class="{'is-invalid': validation.$error}"
             v-model="timeValue"
             @change="emitValue"/>
      <div class="input-group-append">
        <select class="form-control"
                v-bind:class="{'is-invalid': validation.$error}"
                :disabled="disabled"
                title="AM-PM"
                v-model="ampmValue"
                @change="emitValue">
          <option value="AM" :selected="ampmValue === 'AM'">AM</option>
          <option value="PM" :selected="ampmValue === 'PM'">PM</option>
        </select>
      </div>
    </div>
    <div class="invalid-feedback" v-if="validation.$error">
      Invalid time entered
    </div>
  </div>
</template>

<script>
import BaseSelect from '@/components/BaseSelect';
import { ValidationMixin } from '@/js/Mixins';
import { removeAMPM } from '@/js/FormFunctions';

export default {
  inheritAttrs: false,
  mixins: [ValidationMixin],
  name: 'BaseTimePicker',
  props: {
    label: String,
    value: String,
    validation: {
      type: Object,
      default() {
        return {
          $error: false,
          $touch() {},
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { BaseSelect },
  data() {
    return {
      id: null,
      mask: '##:##',
      ampmValue: 'AM',
      timeValue: '',
    };
  },
  mounted() {
    this.id = `timepicker-${this._uid}`;
    if (this.value != null) {
      let val = this.value;
      let ampmIndex = 0;
      if (this.value.indexOf('AM') > -1) {
        ampmIndex = this.value.indexOf('AM');
        this.ampmValue = 'AM';
      } else if (this.value.indexOf('PM') > -1) {
        ampmIndex = this.value.indexOf('PM');
        this.ampmValue = 'PM';
      }
      if (ampmIndex > 0) {
        val = this.value.substring(0, ampmIndex).replace(':', '');
      }
      if (val.length > 0) {
        switch (val.length) {
          case 1:
            this.timeValue = `0${val.substring(0, 1)}:00`;
            break;
          case 2:
            this.timeValue = `${val.substring(0, 1)}${val.substring(1, 2)}:00`;
            break;
          case 3:
            if (val.startsWith('0')) {
              this.timeValue = `${val.substring(0, 1)}${val.substring(1, 2)}:${val.substring(1, 2)}0`;
            } else {
              this.timeValue = `0${val.substring(0, 1)}:${val.substring(1, 2)}${val.substring(2, 3)}`;
            }
            break;
          case 4:
            this.timeValue = `${val.substring(0, 2)}:${val.substring(2, 4)}`;
            break;
          default:
            break;
        }
      }
    }
  },
  methods: {
    emitValue() {
      console.log(`${this.timeValue}${this.ampmValue}`);
      this.$emit('input', `${this.timeValue}${this.ampmValue}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group.is-invalid {
  ~ .invalid-feedback {
    display: block;
  }
}
</style>
